import TopNavigation from "@amzn/awsui-components-react/polaris/top-navigation";
import { getString } from "common/ui_string_labels/ui-strings-utils";
import { BUG_REPORT_URL } from "common/constants/common";
import { CUSTOM_HEADER_TEST_ID } from "helpers";
import { UserPermissions } from "services/user-permissions";
import BugIcon from "./BugIcon";

const getStringPath: string = "common.header";

const CustomHeader = () => {
    return (
        <TopNavigation
            data-testid={CUSTOM_HEADER_TEST_ID}
            identity={{
                href: "/",
                title: getString(`${getStringPath}.title`),
            }}
            utilities={[
                {
                    type: "button",
                    iconSvg: BugIcon,
                    text: getString(`${getStringPath}.bugReport.text`),
                    title: getString(`${getStringPath}.bugReport.title`),
                    href: BUG_REPORT_URL,
                    external: true,
                    externalIconAriaLabel: getString(`${getStringPath}.bugReport.externalIconAriaLabel`),
                    ariaLabel: getString(`${getStringPath}.bugReport.text`),
                },
                {
                    type: "button",
                    text: UserPermissions.instance.getUsername,
                    iconName: "user-profile",
                },
            ]}
        />
    );
};

export default CustomHeader;
